module.exports = __webpack_public_path__ + "img/pyt_1.55581ca9.png";